import { render, staticRenderFns } from "./oeic-share-price-and-charges-panel.vue?vue&type=template&id=e0b5adb2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports